/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Signin_Resend_WaitInputs */

const en_signin_resend_wait = /** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend in ${i?.seconds} s`)
};

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const ar_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const he_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const ur_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const es_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const fr_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const de_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const pt_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const hi_signin_resend_wait = en_signin_resend_wait;

/** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */
const bn_signin_resend_wait = en_signin_resend_wait;

/**
* | output |
* | --- |
* | "Resend in {seconds} s" |
*
* @param {Signin_Resend_WaitInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_resend_wait = /** @type {((inputs: Signin_Resend_WaitInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Resend_WaitInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_resend_wait(inputs)
	if (locale === "he") return he_signin_resend_wait(inputs)
	if (locale === "ur") return ur_signin_resend_wait(inputs)
	if (locale === "es") return es_signin_resend_wait(inputs)
	if (locale === "fr") return fr_signin_resend_wait(inputs)
	if (locale === "de") return de_signin_resend_wait(inputs)
	if (locale === "pt") return pt_signin_resend_wait(inputs)
	if (locale === "hi") return hi_signin_resend_wait(inputs)
	if (locale === "bn") return bn_signin_resend_wait(inputs)
	return en_signin_resend_wait(inputs)
});